import React from 'react';
import './AIAssistant.css';

const AIAssistant = () => {
  return (
    <section className="ai-assistant">

      <div className="ai-assistant-container">

        <div className="ai-assistant-content reveal">
          <span className="eyebrow">Less work, not more</span>
          <h2 className="ai-assistant-headline display">
            We do the thinking.<br />
            <em>You just tap send.</em>
          </h2>

          <p className="ai-assistant-body">
            You already have a POS, an Instagram, an email tool, a payments app.
            The last thing your shop needs is another thing to learn. Every
            morning, Dangol watches your shop&rsquo;s pulse and delivers a
            brief &mdash; what&rsquo;s happening with your dangols, and exactly
            what to do about it.
          </p>

          <div className="ai-assistant-examples">
            <div className="ai-example reveal reveal-delay-2">
              <span className="ai-example-mark display-italic">→</span>
              <p>"<em>Send a &lsquo;we miss you&rsquo; offer to 18 dangols who haven&rsquo;t been in for a month.</em>"</p>
            </div>
            <div className="ai-example reveal reveal-delay-3">
              <span className="ai-example-mark display-italic">→</span>
              <p>"<em>Boost mid-week traffic with a special today &mdash; yesterday was quiet.</em>"</p>
            </div>
          </div>

          <p className="ai-assistant-footer">
            Dangol surfaces the moment, writes the message, picks the timing.
            You review and tap send.
          </p>
        </div>

      </div>
    </section>
  );
};

export default AIAssistant;
